import './vendor';
import vars from './helpers';
import './helpers';
import './components/social';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
import videoJs from 'video.js';
import AOS from 'aos';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

ieFix();
vhFix();
actualYear();
scrollToAnchor.init();

header.init();
lazyLoading.init();

let app = {
	global: {
		init() {
			AOS.init({
				once: true,
			});
		},
	},
	pomade: {
		init($module) {
			const $line = $module.find('.home__pomade-line-anime');
			const $image = $module.find('.home__pomade-image');
			const $imageImg = $module.find('.home__pomade-image img');
			const animation = gsap.timeline()
				.from($line, {
					duration: 1,
					width: 0,
					ease: 'linear',
				})
				.from($image, {
					duration: 1,
					x: $module.outerWidth() - $image.outerWidth() * 0.91,
					ease: 'linear',
				}, 0);

			if (!vars.isMobile()) {
				animation
					.from($imageImg, {
						duration: 0.4,
						y: '-20%',
						ease: 'linear',
					}, 0.6);
			}

			ScrollTrigger.create({
				animation,
				trigger: $module,
				scrub: true,
				// pin: true,
				start: '50% 100%',
				end: '0 0',
				ease: 'linear',
			});
		},
	},
	ink: {
		init($module) {
			const $line = $module.find('.home__ink-line-anime');
			const $image = $module.find('.home__ink-image');
			const animation = gsap.timeline()
				.from($line, {
					duration: 1,
					width: 0,
					ease: 'linear',
				})
				.from($image, {
					duration: 1,
					x: vars.isMobile() ? -$module.outerWidth() + $image.outerWidth() * 0.65 : -$module.outerWidth() + $image.outerWidth() * 0.85,
					ease: 'linear',
				}, 0);

			ScrollTrigger.create({
				animation,
				trigger: $module,
				scrub: true,
				// pin: true,
				start: '50% 100%',
				end: '0 0',
				ease: 'linear',
			});
		},
	},
	game: {
		init($module) {
			const $videos = $module.find('.home__game-item video');
			const $info = $module.find('.home__game-info');
			const $infoClose = $info.find('.home__game-info-close');
			const $infoBegin = $info.find('.home__game-info-begin');
			const $question = $module.find('.home__game-question');
			const $collectPhrase = $module.find('.home__game-button--collect-phrase button');
			const $phraseText = $module.find('.home__game-phrase');
			const $again = $module.find('.home__game-button--again button');
			const $share = $module.find('.home__game-button--share button');
			const $socials = $module.find('.home__game-socials');
			let arr = [];
			let num = 0;
			let getPhrase = '';

			const urlHash = window.location.search;
			const $game = $('#game');

			if (urlHash) {
				window.scrollTo(0, $game.offset().top);

				$.ajax({
					url: 'https://avon-lips.psychologies.ru/get_data/',
					type: 'get',
					dataType: 'json',
					data: {
						hash: new URLSearchParams(window.location.search).get('hash')
					},
					success(response) {
						const arr = JSON.parse(response.json);

						window.scrollTo(0, $game.offset().top);
						$game.addClass('is-hide-info');
						$game.find('.home__game-item').each((index, item) => {
							const video = item.querySelector('video');
							const $video = $(video);

							arr.videos.forEach((arrVideo) => {
								if (arrVideo.number === index + 1) {
									num++;

									window.addEventListener('load', () => {
										video.muted = true;
										setTimeout(() => {
											video.play();
										}, 500)
									})
								}
							})
						})
						$game.find('.home__game-phrase').removeClass('is-hidden');
						$game.find('.home__game-phrase').html(arr.phrase);
						$game.find('.home__game-button--collect-phrase button').prop('disabled', false);
						$game.find('.home__game-button--share button').prop('disabled', false);
					},
				});
			}

			$module.find('.home__game-item').each((index, item) => {
				if (!$(item).hasClass('is-inited')) {
					const $item = $(item);
					const video = item.querySelector('video');
					const $video = $(video);
					const $src = $video.data('src');
					const $poster = $video.data('poster');
					//const $audio = $video.data('audio');
					const audio = item.querySelector('video audio');
					const $videoItem = $video.closest('.home__game-item');
					//let audio = null;

					// if (vars.isMobile()) {
					// 	//audio = new Audio($audio);
					// 	audio.loop = true;
					// }

					$video.addClass('is-inited');

					let player = videoJs(video, {});

					player.src($src);
					player.poster($poster);

					$videoItem.on('click', () => {
						if (player.paused()) {
							if (vars.isMobile()) {
								audio.muted = false;
								audio.pause();
							} else if (!vars.isMobile()) {
								player.muted(false);
							}
							// if (audio) {
							// 	//audio.play();
							// 	audio.muted = false;
							// 	audio.pause();
							// } else {
							// 	player.muted(false);
							// }

							player.play();
							//audio.play();
							$video.removeClass('is-pause');
							$video.addClass('is-play');
							num++;

						} else {
							player.pause();

							if (vars.isMobile()) {
								audio.pause();
							}

							$video.removeClass('is-pause');
							$video.removeClass('is-play');
							$video.addClass('is-pause');

							arr.splice(arr.findIndex((el) => el.number === index + 1), 1);
							num--;
						}

						if (num !== 0) {
							$collectPhrase.prop('disabled', false);
							$share.prop('disabled', false);
						} else {
							$collectPhrase.prop('disabled', true);
							$share.prop('disabled', true);
						}
					})

					if (vars.isMobile()) {
						player.on('play', () => {
							//audio.play();
						})

						player.on('playing', () => {
							audio.currentTime = player.currentTime();
							audio.play();
						})

						player.on('pause', () => {
							audio.pause();
						})
					}

					$item.on('audioLoad', () => {
						if (vars.isMobile()) {
							audio.load();
						}
					})
				}
			});

			$collectPhrase.on('click', () => {
				arr = [];

				$module.find('.home__game-item').each((index, item) => {
					const video = item.querySelector('video');
					const $video = $(video);

					if (!video.paused) {
						// const $phraseArr = $video.data('phrase');
						// const randomNum = Math.floor(Math.random() * $phraseArr.length);

						arr.push({
							number: index + 1,
							second: video.currentTime,
							//phrase: $phraseArr[randomNum],
						});
					}
				})

				$.ajax({
					url: 'https://avon-lips.psychologies.ru/get_phrase/',
					type: 'post',
					data: {
						videos: arr,
					},
					dataType: 'json',
					success(response) {
						$phraseText.removeClass('is-hidden');
						$phraseText.html(response.phrase);
						getPhrase = response.phrase;
						$share.prop('disabled', false);
					},
				});
			});

			$share.on('click', () => {
				$.ajax({
					url: 'https://avon-lips.psychologies.ru/save_data/',
					type: 'post',
					data: {
						videos: arr,
						phrase: getPhrase,
					},
					dataType: 'json',
					success(response) {
						$socials.removeClass('is-hidden');

						$socials.find('button').each((index, item) => {
							$(item).data('url', 'https://avon-lips.psychologies.ru/?hash=' + response.hash).attr('data-url', 'https://avon-lips.psychologies.ru/?hash=' + response.hash)
						})
					},
				});

				$module.find('.home__game-list').addClass('is-disabled');
				$share.closest('.home__game-button--share').addClass('is-hidden');
				$again.closest('.home__game-button--again').removeClass('is-hidden');
				$collectPhrase.closest('.home__game-button--collect-phrase').addClass('is-hidden');
			});

			$again.on('click', () => {
				$module.find('.home__game-list').removeClass('is-disabled');
				$phraseText.addClass('is-hidden');
				$again.closest('.home__game-button--again').addClass('is-hidden');
				$collectPhrase.closest('.home__game-button--collect-phrase').removeClass('is-hidden');
				$collectPhrase.prop('disabled', true);
				$share.closest('.home__game-button--share').removeClass('is-hidden');
				$socials.addClass('is-hidden');
				$share.prop('disabled', true);
				arr = [];

				$module.find('.home__game-item').each((index, item) => {
					const $item = $(item);
					const video = item.querySelector('video');
					const $video = $(video);

					if (!video.paused) {
						video.load();
						$item.trigger('audioLoad');

						$video.removeClass('is-play');
						$video.removeClass('is-pause');
					}
				})
			});

			$infoClose.on('click', () => {
				$module.addClass('is-hide-info');
			});

			$infoBegin.on('click', () => {
				$module.addClass('is-hide-info');
			});

			$question.on('click', () => {
				if (vars.isMobile()) {
					window.scrollTo( {
						left: 0,
						top: $module.offset().top,
						behavior: 'smooth'
					});
				}

				$module.removeClass('is-hide-info');
				$module.find('.home__game-info-begin').addClass('is-hidden');
			});
		},
	},
	gameAnimation: {
		init($module) {
			const $button = $('.home__button');
			const $buttonBg = $button.find('.home__button-bg');
			const $buttonSvg = $button.find('svg');
			let scroll = null;
			const animation = gsap.timeline()
				.to($buttonBg, {
					duration: 1,
					scale: 40,
					ease: 'linear',
					onComplete() {
						$module.addClass('is-animate');
						scroll.kill();
						vars.lockScroll(true, $module);
						setTimeout(() => {
							gsap.set([$button, $buttonBg, $buttonSvg], {clearProps: 'all'});
						});
						setTimeout(() => {
							window.scrollTo({
								top: $module.offset().top,
							});
						}, 100);
						setTimeout(() => {
							vars.lockScroll(false, $module);
						}, 1000);
					}
				})
				.to($buttonSvg, {
					duration: 0.25,
					autoAlpha: 0,
					ease: 'linear',
				}, '<')

			scroll = ScrollTrigger.create({
				animation,
				trigger: $button,
				scrub: true,
				pin: true,
				pinSpacing: false,
				start: () => $module.offset().top - window.outerHeight * 0.9,
				end: () => $module.offset().top,
				ease: 'linear',
			});
		},
	},
};

app.global.init();

window.initApps = () => {
	$('[data-app]').each((index, item) => {
		let $this = $(item);
		let split = $this.data('app').split('||');

		$.each(split, (appIndex, appName) => {
			let appNameCamel = false;

			if (appName.indexOf('-') !== -1) {
				appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
			}

			if (app[appName] && $this.data(`${appName}-init`) !== true) {
				app[appName].init($this);
				$this.data(`${appName}-init`, true);
			} else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
				app[appNameCamel].init($this);
				$this.data(`${appName}-init`, true);
			}
		});
	});
};

initApps();
